import axios from "axios";
import {
  SET_LOADER,
  CLEAR_LOADER,
  CLEAR_ERRORS,
  GET_VENDOR_ALL_OFFERS,
  GET_VENDOR_ALL_EVENTS,
  GET_ONLINE_VIEW_EVENT,
} from "../types";

import Alert from "react-s-alert";

import { setErrors } from "../actions/errorActions";
import { serverApi } from "../../config/Keys";
import { errorAlert } from "../../function/alert";

/***************************************
 * @DESC - ADD OFFERS AND EVENTS ACTION
 *****************************************/
export const vendor_create_new_offer =
  (
    formData,
    token,
    onSuccess
    // onError
  ) =>
    async (dispatch) => {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER });
      try {
        let create_offer = await axios.post(`${serverApi}/offers`, formData, {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        });
        if (create_offer.data) {
          dispatch({ type: CLEAR_LOADER });
          Alert.success("<h4>New Offer Added Successfully</h4>", {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
          onSuccess();
          // dispatch(get_offers_details(token));
        }
      } catch (err) {
        dispatch({ type: CLEAR_LOADER });
        dispatch(setErrors(err));
        Alert.error(`<h4>${err.response.data.message}</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        // onError();
      }
    };

export const vendor_create_new_events =
  (formData, token, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let create_events = await axios.post(`${serverApi}/events`, formData, {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      });
      if (create_events.data) {
        dispatch({ type: CLEAR_LOADER });
        Alert.success("<h4>New Events Add Successfully</h4>", {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        dispatch(get_events_details(token));
        onSuccess();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - GET VIEW DASHBOARD ONLINE EVENTS ACTION
 *****************************************/
export const get_view_dashboard_online_event =
  (token, vendorId, eventId, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_online_event = await axios.get(
        `${serverApi}/event-handler?vendor_id=${vendorId}&event_id=${eventId}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (get_online_event.status === 200) {
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
        dispatch({
          type: GET_ONLINE_VIEW_EVENT,
          payload: get_online_event.data,
        });
      }
    } catch (err) {
      //onErrorReviews();
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - GET OFFERS AND EVENTS ACTION
 *****************************************/
export const get_offers_details = (token) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER });
  try {
    let get_offersDetails = await axios.get(`${serverApi}/offers`, {
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
    });
    if (get_offersDetails.status === 200) {
      dispatch({
        type: GET_VENDOR_ALL_OFFERS,
        payload: get_offersDetails.data,
      });
      dispatch({ type: CLEAR_LOADER });
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

export const get_events_details = (token) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER });
  try {
    let get_eventsDetails = await axios.get(`${serverApi}/events`, {
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
    });
    if (get_eventsDetails.status === 200) {
      dispatch({
        type: GET_VENDOR_ALL_EVENTS,
        payload: get_eventsDetails.data,
      });
      dispatch({ type: CLEAR_LOADER });
    }
  } catch (err) {
    console.log(err);
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

/***************************************
 * @DESC - EDIT OFFERS AND EVENTS ACTION
 *****************************************/
export const vendor_update_offer =
  (formData, offerId, token, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let update_offer = await axios.patch(
        `${serverApi}/offers/${offerId}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (update_offer.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        Alert.success("<h4>Offer Update Successfully</h4>", {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onSuccess();
        dispatch(get_offers_details(token));
      }
    } catch (err) {
      errorAlert(err?.response?.data?.message || 'Something went wrong')
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const vendor_update_events =
  (formData, eventId, token, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let update_events = await axios.patch(
        `${serverApi}/events/${eventId}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (update_events.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        onSuccess();
        dispatch(get_events_details(token));
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - DELETE OFFERS AND EVENTS ACTION
 *****************************************/
export const delete_Offers =
  (offerId, token, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let delete_data = await axios.delete(`${serverApi}/offers/${offerId}`, {
        headers: {
          Authorization: token,
        },
      });
      if (delete_data.data) {
        dispatch({ type: CLEAR_LOADER });
        Alert.success("<h4>Offer Delete Successfully</h4>", {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onSuccess();
        dispatch(get_offers_details(token));
      }
    } catch (err) {
      console.log(err);
    }
  };

export const delete_Events =
  (eventId, token, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let delete_data = await axios.delete(`${serverApi}/events/${eventId}`, {
        headers: {
          Authorization: token,
        },
      });
      if (delete_data.data) {
        dispatch({ type: CLEAR_LOADER });
        Alert.success("<h4>Event Delete Successfully</h4>", {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onSuccess();
        dispatch(get_events_details(token));
      }
    } catch (err) {
      console.log(err);
    }
  };
